import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7285a5f6"
import script from "./vuetifyDataTable.js?vue&type=script&lang=js&external"
export * from "./vuetifyDataTable.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=7285a5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports